/* ************************************************************************************
 * ON OFF SWITCH MAP
 */

/* ************************************************************************************
 * GLOBAL VARIABLE
 */

var numberLineOld;
var strokeWidthNormal = '1.5px';
var strokeWidthBig = '7px';
var colorBaseStamp = '#FFFFFF';

var idStampParentOld;
var stampOld;
var stampPathOld;
var stampParentOld;

/**
 * controlla lo switch tra mappa urbana ed interurbana
 *
 * @param event
 */
function onOffInteractiveMaps(event) {
    event.stopImmediatePropagation;

    var flipswitchCheckbox = event;
    var flipswitch = event.parent();
    var idName = flipswitch.attr('id');

    var cityMap = $('#city-map-wrapper');
    var interurbanMap = $('#interurban-map-wrapper');

    switch(idName) {
        case 'onoffswitch-city':

            if( flipswitchCheckbox.hasClass('checked') ) {
                onOff($('#onoffswitch-checkbox-interurban'), flipswitchCheckbox);
                fadeMap(interurbanMap, cityMap);
            } else {
                onOff(flipswitchCheckbox, $('#onoffswitch-checkbox-interurban'));
                fadeMap(cityMap, interurbanMap);
            }

            break;

        case 'onoffswitch-interurban':

            if( flipswitchCheckbox.hasClass('checked') ) {
                onOff($('#onoffswitch-checkbox-city'), flipswitchCheckbox);
                fadeMap(cityMap, interurbanMap);
            } else {
                onOff(flipswitchCheckbox, $('#onoffswitch-checkbox-city'));
                fadeMap(interurbanMap, cityMap);
            }

            break;
    }
}

function onOff(elementOn, elementOff) {
    elementOn.addClass('checked');
    elementOff.removeClass('checked');
}

function fadeMap(mapOn, mapOff) {
    resetMap();

    mapOn.velocity("fadeIn", { duration: 300 });
    mapOff.velocity("fadeOut", { duration: 0 });
}

function resetMap() {
    /**
     * Porta allo step 1 della legend
     */
    $('.legend-map .step').hide();
    $('.legend-map .step-1-2, .legend-map .step-1-3').show();
    $('#interurban-legend-map .list-number-bus-line').empty();

    /**
     * Reset delle linee
     */
    hideAllInterurbanLine();
    changeWidthPath($('.city-map'), strokeWidthNormal);
    resetColorText();
    removeClassActiveInStampRoute();

    if(stampParentOld != undefined) {
        changeWeightTextRoute($('.city-map'), '500', true);
        resetPath(stampOld, stampParentOld);
        idStampParentOld = 0;
    }
}

/**
 * Inizializza mappa
 */
onOff($('#onoffswitch-checkbox-city'), $('#onoffswitch-checkbox-interurban'));

/* ************************************************************************************
 * CITY MAP
 */

inizializeCityMap();

function inizializeCityMap() {
    /**
     * variabili
     * @type {*|jQuery|HTMLElement}
     */
    var stamp;
    var stampParent;
    var idStampParent;
    var stampPathColor;

    $('.stamp').on('touchstart mouseup', function(e) {

        e.preventDefault();

        stamp = $(this);
        stampParent = stamp.parent();
        idStampParent = stampParent.attr('id').slice(6);
        stampPathColor = stamp.find('path').attr('fill');

        /**
         * verifica se è già stato fatto il click sullo stesso elemento
         * già attivo
         * se true inzializza la funzione che porta alla pagina orari
         */

        if(idStampParent == idStampParentOld) {

            goToLine('URB', idStampParent);

        } else {

            if(stampParentOld != undefined) {

                resetPath(stampOld, stampParentOld);

                changeWeightTextRoute($('.city-map'), '500', true);
            }

            changeWidthPath(stampParent, strokeWidthBig);
            changeStamp(stampParent, colorBaseStamp, stampPathColor);
            changeWeightTextRoute(stampParent, '900', false);

            goToLegendNextStepInCityMap(idStampParent, stampPathColor);

            //checkRouteCustomAlert(idStampParent, "URB");
        }

        stampOld = stamp;
        stampParentOld = stampParent;
        idStampParentOld = idStampParent;

    });
}

var customAlertRoutes = {
    "URB": ["ROVR", "CC", "9", "8", "7M", "7E", "6", "5", "4T", "4S", "4CS", "4C", "12", "11"],
    "EXT": ["2", "6", "7", "10", "11", "15", "16A", "17S", "20", "23", "28", "29", "31A", "35", "46", "57A"]
};

var url_routeCircledIdentifierData = Routing.generate("get_route_circled_identifier_data");
var routeCustomAlertModal = $("#modal-route-custom-alert");


/**
 * controlla se mostrare un messaggio custom per la linea
 *
 * @param route
 * @param agency
 */
function checkRouteCustomAlert(route, agency) {
    if(inArray(route, customAlertRoutes[agency])) {

        routeCustomAlertModal.find(".involve-type-wrapper").html('');
        routeCustomAlertModal.modal("show");

        $.get(url_routeCircledIdentifierData, {
            "agency": agency,
            "route": route
        }, function (data) {
            data = JSON.parse(data);
            if(typeof data.route != "undefined") {
                routeCustomAlertModal.find(".involve-type-wrapper").html('' +
                '<ul class="list-alert list-inline">' +
                    '<li>' +
                        '<div class="transit-bus-line-number font-20 c-white" style="background-color: #'+data.route.color+';">' +
                            route +
                            '<em class="fa fa-exclamation-triangle c-red" aria-hidden="true"></em>' +
                        '</div>' +
                    '</li>' +
                '</ul>');
            }
        });
    }
}

/**
 * resetta la linea che non è più attiva
 *
 * @param stampOld
 * @param stampParentOld
 */
function resetPath(stampOld, stampParentOld) {
    var stampPathOld = stampOld.find('path');
    var stampPathOldColor = stampPathOld.attr('fill');

    changeWidthPath(stampParentOld, strokeWidthNormal);
    changeStamp(stampParentOld, stampPathOldColor, colorBaseStamp);
}

/**
 * aumenta o diminuisce lo spessore della linea bus
 *
 * @param e
 */
function changeWidthPath(e, strokeW) {
    var linePath = e.find('.line-path > *');

    linePath.velocity({ strokeWidth: strokeW });
}

/**
 * cambia l'aspetto del bollo
 *
 * @param path, text, color1, color2
 */
function changeStamp(parent, color1, color2) {

    /**
     * trasforma gli elementi svg
     */
    $(parent).find('.stamp').find('path').velocity({ fill: color1, stroke: color2 });
    $(parent).find('.stamp').find('text').velocity({ fill: color2 });
    $(parent).find('.stamp').find('text > tspan').velocity({ fill: color2 });
}

function changeWeightTextRoute(element, fontWeight, reset) {

    if (reset == true) {
        element.find('.text-route, .text-route > tspan').removeAttr('style');
    } else {
        element.find('.text-route, .text-route > tspan').css("font-family", "\'Museo Sans " + fontWeight + "\'");
    }
}

function goToLegendNextStepInCityMap(e, colorPath) {
    var step1 = $('#city-legend-map .step-1-2');
    var step2 = $('#city-legend-map .step-2-2');

    step1.hide();
    step2.velocity("fadeIn", { duration: 300 });

    step2
        .find('.map-line-number-wrapper')
        .css('background-color', colorPath)
        .attr("href", Routing.generate("maps", {'route': 'URB-' + e}));
    step2
        .find('.map-line-number')
        .text(e);
}

/**
 * al secondo click sullo stesso elemento
 * cambia pagina all'url della linea bus scelta
 *
 * @param e
 */
function goToLine(mapType, e) {

    $.get(Routing.generate("check_if_route_is_available", {
        "routeShortName": e,
        "agency_id": mapType
    }), function(output) {
        if(output == 1) {
            window.location.href = Routing.generate("maps", {'route': mapType + '-' + e});
        } else {
            $('#modal-route-alert').find("#modal-route-alert-route-code").text(e);
            $('#modal-route-alert').modal('show');
        }
    });

    return false;
}

/* ************************************************************************************
 * INTERURBAN
 */

inizializeInterurbanMap();

function inizializeInterurbanMap() {
    /**
     * variabili
     * @type {*|jQuery|HTMLElement}
     */
    var country;
    var nameCountry;
    var dataJson;

    /**
     * importo il file con l'elenco dei paesi della provincia di mantova
     * con le relative linee di passaggio
     */
    $.getJSON('/assets/interurban-countries-list.min.json', function( data ) {
        dataJson = data;
    });

    $('.country').on('touchstart mouseup', function(e) {

        e.preventDefault();

        country = $(this);
        nameCountry = country.attr('data-name');

        hideAllInterurbanLine();
        deleteInterurbanLineInStep();
        goToLegendNextStepInInterurbanMap(2, nameCountry);
        changeWidthPath($('.interurban-map'), strokeWidthNormal);
        resetColorText();
        changeColorText(country);
        removeClassActiveInStampRoute();
        numberLineOld = 0;

        for (var itemCountry in dataJson.countries) {

            if(itemCountry == nameCountry) {

                for (var busLine in dataJson.countries[itemCountry]) {

                    var numbersBusLine = dataJson.countries[itemCountry][busLine].line;
                    var idBusLine = '#linea-e-' + numbersBusLine;

                    showInterurbanLine(idBusLine);
                    printInterurbanLineInStep(idBusLine, numbersBusLine);
                }
            }
        }
    });
}

/**
 * Nasconde tutti path delle linee
 */
function hideAllInterurbanLine() {
    $('.interurban-map .line-group').velocity("fadeOut", { duration: 300 });
}

/**
 * Mostra i path delle linee
 *
 * @param idBusLine
 */
function showInterurbanLine(idBusLine) {
    $(idBusLine).velocity("fadeIn", { duration: 300 });
}

/**
 * Rimuove i bolli delle linee selezionabili nella legenda
 */
function deleteInterurbanLineInStep() {
    $('#interurban-legend-map .list-number-bus-line li').remove();
}

/**
 * Rimuove la classe active dai bolli nella mappa
 */
function removeClassActiveInStampRoute() {
    $('.interurban-map .stamp-ext').removeClass('active');
}

/**
 * Cambia il colore del paese selezionato
 *
 * @param country
 */
function changeColorText(country) {
    if (country.find('text').children().length) {
        var textCountry = country.find('text > tspan');
    } else {
        var textCountry = country.find('text');
    }

    textCountry.velocity({ fill: '#cb0512' });
}

function resetColorText() {
    $('.country').find('text').velocity({ fill: '#878787' });
    $('.country').find('text > tspan').velocity({ fill: '#878787' });
}

/**
 * Stampa nella legenda una lista delle linee selezionabili
 *
 * @param idBusLine
 * @param numbersBusLine
 */
function printInterurbanLineInStep(idBusLine, numbersBusLine) {
    $('#interurban-legend-map .list-number-bus-line').append('<li>'                                                                                         +
            '<a class="c-white font-26" data-route-number="' + numbersBusLine + '" href="javascript:void(0);" onclick="numberBusInterurbanLine($(this),\'' + idBusLine + '\', \'' + numbersBusLine + '\');">'  +
                numbersBusLine                                                                                                                              +
            '</a>'                                                                                                                                          +
        '</li>');
}

/**
 * Gestisce il duplice click sul bollo della linea selezionata
 *
 * @param e
 * @param numbersBusLine
 */
function numberBusInterurbanLine(e, idBusLine, numbersBusLine) {

    var element = $(idBusLine);
    var numberLineNew = numbersBusLine;

    if(numberLineOld == numberLineNew) {

        /**
         * Gestisce il secondo click
         */
        goToLine('EXT', numberLineNew);

    } else {
        /**
         * Gestisce il primo click
         */
        changeWidthPath($('.interurban-map'), strokeWidthNormal);
        $('#interurban-legend-map .list-number-bus-line > li > a').removeClass('active');
        removeClassActiveInStampRoute();
        changeWidthPath(element, strokeWidthBig);

        goToLegendNextStepInInterurbanMap(3, numberLineNew);

        $(e).addClass('active');
        $(element).find('.stamp-ext').addClass('active');
        $('#interurban-legend-map .list-number-bus-line > li > a[data-route-number="' + numbersBusLine + '"]').addClass('active');

        numberLineOld = numberLineNew;

        //checkRouteCustomAlert(numbersBusLine, "EXT");
    }
}

/**
 * Avanza gli step nella legenda
 *
 * @param step
 * @param countrySelected
 */
function goToLegendNextStepInInterurbanMap(step, countrySelected) {

    var stepElement = '#interurban-legend-map .step-';
    var numberStepPrev = step -1;
    var numberStepCurrent = step;

    if(numberStepCurrent == 2) {
        var numberStepNext = step +1;
        var stepNext = $(stepElement + numberStepNext + '-3');

        stepNext.hide();
    }

    var stepPrev = $(stepElement + numberStepPrev + '-3');
    var stepCurrent = $(stepElement + numberStepCurrent + '-3');

    stepPrev.hide();
    stepCurrent.velocity("fadeIn", { duration: 300 });

    if(numberStepCurrent == 2) {
        stepCurrent
            .find('.map-country-name')
            .text(countrySelected);
    } else if (numberStepCurrent == 3) {
        stepCurrent
            .find('.map-line-number')
            .text(countrySelected);
        stepCurrent
            .find('.map-line-number-wrapper')
            .attr("href", Routing.generate("maps", {'route': 'EXT-' + countrySelected}));
    }
}